/**
 * KAN-845: на вкладке "Внимание" открывает экран "Начало работы", пока есть
 * несделанный обязательный шаг и менеджер не нажал "Готово".
 * Стоит только на /m: переход из уведомления к клиенту не перехватывается.
 */
import { Navigate } from 'react-router-dom';
import { useOnboardingSteps } from '@/hooks/useOnboardingSteps';
import { MOBILE_START_PATH } from '@/lib/mobileApp';
import { ONBOARDING_NAV_STATE } from '@/lib/managerOnboarding';

export function OnboardingAutoOpen(): JSX.Element | null {
  const { shouldAutoOpen } = useOnboardingSteps();
  return shouldAutoOpen ? <Navigate to={MOBILE_START_PATH} state={ONBOARDING_NAV_STATE} replace /> : null;
}
